module.exports = __webpack_public_path__ + "static/media/HL6.ac38a032.jpg";